// extracted by mini-css-extract-plugin
export default {"profilePhoto":"UserSettings-module__profilePhoto--afa0"};